import { styled } from "@mui/material/styles";

export const HeaderArea = styled("div")(({ theme }) => ({
  color: theme.custom.colors.mediGray,
  flexShrink: 0,
  zIndex: 40,
  boxShadow: "0px 2px 3px rgb(174 188 197 / 50%)",
}));
